import { useRef,  useState , memo , useCallback} from 'react';
import Map from '../components/map/Map.js'
import Grid from '@mui/material/Grid'
import {useFetchFlowers} from '../hooks/useFetchFlowers'
import {Marker ,  Tooltip} from 'react-leaflet'
import Header from "../components/Header";
import MapControlFlower from '../components/map/MapControlFlower.js'
import MapCardFlower from '../components/map/MapCardFlower.js'
import MapListFlower from '../components/map/MapListFlower.js'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {useSharedLang} from '../hooks/useSharedLang.js';
import {LANGS, MAPS , geoPositionOptions} from "../components/constants.js";
import Loading from "../components/Loading.js";
import { useModal } from 'react-hooks-use-modal';
import styles from '../styles/modal.module.css';
import { Helmet } from "react-helmet-async";
import {useGeolocated} from '../hooks/useGeolocated';
import {useDikstra} from '../hooks/useDikstra';
import {getIcon, getTooltipOptions} from "../utils/UrlUtil.js";
import {AutumnIcon} from '../components/map/MapIcon.js'

const Flower = memo(() => {

  const mapRef = useRef(null);

  const {flowerList, isLoading} = useFetchFlowers();

  const defaultSelectedFlower = useRef(null);
  const isUseDefaultSelectedFlower = useRef(true);
  const activeFlowerList = useRef(null);
  const { id } = useParams();

  const [selectedSeasonList, setSelectedSeasonList] = useState([]);
  const [selectedFlower , setSelectedFlower] = useState(null);
  
  const [isNarrowDown , setIsNarrowDown] = useState(false); //絞り込み状態
  const [isList , setIsList] = useState(false); //一覧表示状態
  const selectedMarkerKey = useRef(null);

  const { t } = useTranslation();
  const { sharedLang } = useSharedLang();

  /**
   * リアルタイム座標チェック
   * 
   * @param {*} pos 
   */
  const setCurrentPosition = (pos) => {
    //現在地をマップに表示
    if(mapRef.current != null){
        mapRef.current.updateMarker(pos.coords.latitude, pos.coords.longitude);
        lastCoords.current =  pos;
    }
    //-- 自動ポップアップはしない
    // activeFlowerList.current.map((element, fIndex) =>
    //     element.positions.map((position, pIndex) => {
    //         if(getDistance(
    //             pos.coords.latitude , pos.coords.longitude , 
    //             position.latitude, position.longitude) <= MAPS.AUTO_POPUP_DISTANCE){
                
    //                 clickMarker(element , position);
    //         }
    //     }
    // ));
  };
  
  const [Modal, modalOpen , modalClose, isOpen] = useModal(
    'root', {
      preventScroll: true ,
      components :{
      Wrapper: ({ children }) => {
          return <div className={styles.modal360}>{children}</div>;
        }
      }
    }
  );

  //--- 現在地 ---
  //useGeolocated の coordsは使わない。使うと座標が更新されるたびに画面が再描写してしまう。
  const { isGeolocationAvailable, isGeolocationEnabled  } = useGeolocated({
    ...geoPositionOptions , 
    onSuccess : (pos) => setCurrentPosition(pos),
  });
  const lastCoords = useRef(null);
  const { getDistance} = useDikstra({})

  const isActiveMarker = useCallback((markerkey) => {
    return selectedMarkerKey.current === markerkey;
  },[]);

  const getMarkerKey = useCallback((flower , coordinate) => {
    return flower.id + '-' + coordinate[0] + '-' + coordinate[1];
  },[]);

  const toggleSeason = useCallback((codes) => {
    setSelectedSeasonList(codes);
  },[]);

  const toggleNarrowDown = useCallback((flg) => {
    setIsNarrowDown(flg);
  },[]);

  const toggleList = useCallback((flg) => {
    setIsList(flg);
    setIsNarrowDown(false);
  },[]);

  const clickMarker = (flower, coordinate) => {
    selectedMarkerKey.current = getMarkerKey(flower, coordinate);
    setSelectedFlower(flower);
  };

  const selectFlower = (flower) => {
    selectedMarkerKey.current = null;
    setIsNarrowDown(true);
    setSelectedFlower(flower);
    setIsList(false);
  };

  const resetMarker = useCallback(() => {
    selectedMarkerKey.current = null;
    isUseDefaultSelectedFlower.current = false;

    setSelectedFlower(null);
    setIsNarrowDown(false);
  },[]);
  
  const getActiveSeasonFlower = () => {
    let elements = [];
    if(isLoading){
      return elements;
    }
    let currentElement = getActiveElement();
    
    for (let index = 0; index < flowerList.length; index++) {
      let flower = flowerList[index];

      if(sharedLang === LANGS.ENGLISH){
        flower.name = flower.nameEnglish;
        flower.area = flower.areaEnglish;
        flower.seasons.period = flower.seasons.periodEnglish;
        flower.description = flower.descriptionEnglish;
      }
      if(flower.name == ""){
        //名前がなければ飛ばす
      }
      // 絞り込み表示の場合
      else if(isNarrowDown && currentElement != null){
        if(flower.id === currentElement.id){
          elements.push(flower);
        }
      }
      // 絞り込み表示じゃない場合
      else{
        var season = flower.seasons.season;
        if(selectedSeasonList.includes(season)){
          elements.push(flower);
        }else if(season === "all"){
          elements.push(flower);
        }
      }
    }
    return elements;
  };

  const getActiveElement = useCallback(() => {
      let ret = selectedFlower;
      if(selectedFlower == null && isUseDefaultSelectedFlower.current){
          ret = defaultSelectedFlower.current;
      }
      return ret;
  },[selectedFlower]);

  if (isLoading) {
    return (<Loading></Loading>);
  }
  activeFlowerList.current = getActiveSeasonFlower();

  if(id && defaultSelectedFlower.current == null){
    activeFlowerList.current.forEach((element) =>{
      if(String(element.id) === id){
        defaultSelectedFlower.current = element;
        selectFlower(element);
      }
    })
  }

  return (
    <>
    <Helmet>
      <title>{t("meta.title")}</title>
    </Helmet>
    <Header 
      display={true} 
      title={t("nature.title")}
      isList={isList} 
      toggleList={toggleList} />
    
    <Grid container justifyContent="center" alignItems="center" direction="column">
      {isList?
      <MapListFlower 
        flowers={activeFlowerList.current}
        selectFlower={selectFlower}
      />  :
      <>
      <Map ref={mapRef}>
      {
        activeFlowerList.current.map((element, fIndex) =>
            element.positions.map((position, pIndex) => {
              let coordinate = [position.latitude, position.longitude];
              let markerKey = getMarkerKey(element, coordinate);
              
              return <Marker
                  key={markerKey}
                  position={coordinate}
                  icon={getIcon(element.markerIcon , AutumnIcon)}
                  eventHandlers={{
                    click: (e) => {
                      clickMarker(element, coordinate);
                    }
                  }}
                >
                {
                isActiveMarker(markerKey)
                //true
                ?<Tooltip {...getTooltipOptions(
                  fIndex + pIndex , 
                  coordinate,
                  element.category
                )}
                  >
                    {element.name}
                  </Tooltip>
                : <></>
                }
              </Marker>
            })
        )
      }
        {
          selectedFlower == null &&
          <MapControlFlower 
                selectedSeasonList={selectedSeasonList} 
                toggleSeason={toggleSeason} />
        }
    </Map>
    <MapCardFlower 
      flower={getActiveElement()} 
      resetMarker={resetMarker} 
      isNarrowDown={isNarrowDown} 
      toggleNarrowDown={toggleNarrowDown} 
      modalOpen={modalOpen} />
    </>
    }    
  </Grid>
  </>
  )
});
export default Flower